/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatpresetemailheader3Inputs */

const en_formatpresetemailheader3 = /** @type {(inputs: Formatpresetemailheader3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Header`)
};

const de_formatpresetemailheader3 = /** @type {(inputs: Formatpresetemailheader3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Header`)
};

/**
* | output |
* | --- |
* | "Email Header" |
*
* @param {Formatpresetemailheader3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatpresetemailheader3 = /** @type {((inputs?: Formatpresetemailheader3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatpresetemailheader3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatpresetemailheader3(inputs)
	return de_formatpresetemailheader3(inputs)
});
export { formatpresetemailheader3 as "formatPresetEmailHeader" }